import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import { Tab } from "@material-ui/core";
import { Typography, Grid, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
    maxWidth: "350px"
  },
  checkboxError: {
    color: "red"
  },
  actionsContainer: {
    marginTop: theme.spacing(3)
  },
  menu: {
    width: 200
  }
});

const ccalc_baserate = (baserate, conv_euro) =>
  baserate === 0 ? 1 / conv_euro : baserate;

const ccalc_value = (token, baserate, conv, conv_euro) =>
  conv * ccalc_baserate(baserate, conv_euro) * token;

const ccalc_token = (value, baserate, conv, conv_euro) =>
  (1 / (conv * ccalc_baserate(baserate, conv_euro))) * value;

class EnterMulticurrencyInvestmentValue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currency: props.value.currency,
      value_currency: 0,
      value_token: Math.max(props.min_token + 1, props.value.token)

      /*
    https://www.cryptocompare.com/api/#-api-data-price- 
    https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=EUR,ETH,BTC,DASH,CHF
    */
    };

    this.state.value_token_display = Math.round10(this.state.value_token, -6);
    this.state.value_currency = ccalc_value(
      this.state.value_token,
      props.conversion.conv.baserate,
      props.conversion.conv.rate[this.state.currency],
      this.props.conversion.conv.rate["EUR"]
    );
    this.state.value_currency_display = Math.round10(
      this.state.value_currency,
      -6
    );

    this.props.setFieldValue(props.name, {
      ...props.value,
      token: this.state.value_token.toString(),
      sum: this.state.value_currency.toString(),
      display: {
        token: this.state.value_token_display.toString(),
        sum: this.state.value_currency_display.toString()
      },
      currency: this.state.currency,
      conversion: this.props.conversion
    });
  }

  componentDidMount() {
    this.handleChangeCurrency(null, this.state.currency);
  }

  handleChangeCurrency = (event, currency) => {
    this.setState({ currency }, () => {
      this.calcConversion("value_token", this.state.value_token);
    });
  };

  calcConversion(name, value) {
    let value_token,
      value_token_display,
      value_currency,
      value_currency_display;
    if (name === "value_token") {
      //tab change
      value_token = value;
      value_currency = ccalc_value(
        value_token,
        this.props.conversion.conv.baserate,
        this.props.conversion.conv.rate[this.state.currency],
        this.props.conversion.conv.rate["EUR"]
      );
    } else {
      //field value change
      value_currency = value;
      value_token = ccalc_token(
        value_currency,
        this.props.conversion.conv.baserate,
        this.props.conversion.conv.rate[this.state.currency],
        this.props.conversion.conv.rate["EUR"]
      );
    }
    value_token_display = Math.round10(value_token, -6);
    value_currency_display = Math.round10(
      value_currency,
      this.state.currency === "EUR" ? -2 : -6
    );
    this.setState({
      value_token,
      value_token_display,
      value_currency,
      value_currency_display
    });

    this.props.setFieldValue(this.props.name, {
      ...this.props.value,
      token: value_token.toString(),
      sum: value_currency.toString(),
      display: {
        token: value_token_display.toString(),
        sum: value_currency_display.toString()
      },
      currency: this.state.currency,
      conversion: this.props.conversion
    });
  }

  handleChangeValue = event => {
    event.preventDefault();
    const value = event.target.value;
    const name = event.target.name;

    this.calcConversion(name, value);
  };

  render() {
    const { props } = this;

    const { classes } = props;
    const {
      currency,
      value_currency_display,
      value_token_display
    } = this.state;
    const baserate_disp = Math.round10(
      ccalc_baserate(
        this.props.conversion.conv.baserate,
        this.props.conversion.conv.rate[this.state.currency]
      ),
      -6
    ).toLocaleString();
    const euro_rate_disp = Math.round10(
      ccalc_value(
        1,
        this.props.conversion.conv.baserate,
        this.props.conversion.conv.rate["EUR"],
        this.props.conversion.conv.rate["EUR"]
      ),
      -2
    ).toLocaleString();
    const dash_rate_disp = Math.round10(
      ccalc_value(
        1,
        this.props.conversion.conv.baserate,
        this.props.conversion.conv.rate["DASH"],
        this.props.conversion.conv.rate["EUR"]
      ),
      -6
    ).toLocaleString();
    const rate_date_tmp = new Date(
      this.props.conversion.conv.timestamp
    ).toISOString();
    const rate_date_disp =
      rate_date_tmp.substr(0, 16) +
      rate_date_tmp.substr(rate_date_tmp.length - 1, 1);

    return (
      <Paper elevation={0}>
        <Tabs
          value={currency}
          onChange={this.handleChangeCurrency}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab value="ETH" label="ETH" className="ethTab" />
          <Tab value="EUR" label="EUR" className="eurTab" />
          <Tab value="DASH" label="DASH" className="dashTab" />
        </Tabs>
        {/* {currency === "ETH" && <TabContainer>Item One</TabContainer>}
        {currency === "EUR" && <TabContainer>Item Two</TabContainer>}
        {currency === "DASH" && <TabContainer>Item Three</TabContainer>} */}
        <TabContainer>
          <Grid container spacing={10}>
            <Grid item xs={12} sm={12}>
              {currency === "ETH" && (
                <Typography>
                  Use this payment method to send ETH from a ERC20
                  Token-compatible wallet.
                </Typography>
              )}
              {currency === "EUR" && (
                <Typography>
                  Use this payment method to make a SEPA transaction directly to
                  our bank.
                </Typography>
              )}
              {currency === "DASH" && (
                <Typography>
                  Use this payment method to send DASH with CoinPayments.net.
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                type="number"
                name="value_token"
                label="Token to buy"
                className={classes.textField}
                onChange={this.handleChangeValue}
                value={value_token_display}
                required
                onBlur={props.handleBlur}
                //error={typeof props.errors.full_first_name !== "undefined"}
                // helperText={
                //   props.errors.full_first_name &&
                //   props.touched.full_first_name
                //     ? props.errors.full_first_name
                //     : "All names as written on your ID document - using the same alphabet and letters."
                // }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                type="number"
                name="value_currency"
                label={"Sum to spend, " + currency}
                className={classes.textField}
                onChange={this.handleChangeValue}
                value={value_currency_display}
                required
                onBlur={props.handleBlur}
                // error={typeof props.errors.full_last_name !== "undefined"}
                // helperText={
                //   props.errors.full_last_name && props.touched.full_last_name
                //     ? props.errors.full_last_name
                //     : "All last names as written on your ID document - using the same alphabet and letters."
                // }
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              {currency === "ETH" && (
                <React.Fragment>
                  <Typography align="right">
                    <small>
                      (1&nbsp;CRWD-Token / {baserate_disp}&nbsp;ETH -{" "}
                      <span style={{ whiteSpace: "nowrap" }}>
                        {rate_date_disp}
                      </span>
                      )
                    </small>
                  </Typography>
                </React.Fragment>
              )}
              {currency === "EUR" && (
                <React.Fragment>
                  <Typography align="right" gutterBottom>
                    <small>
                      (1&nbsp;CRWD-Token / {baserate_disp}&nbsp;ETH /{" "}
                      {euro_rate_disp}&nbsp;EURO -{" "}
                      <span style={{ whiteSpace: "nowrap" }}>
                        {rate_date_disp}
                      </span>
                      )
                    </small>
                  </Typography>
                  <Typography>
                    <b>Please note:</b> Funds received to our account within 3
                    business days of purchase will be processed for the amount
                    of tokens listed in the original order. If funds are not
                    received within 3 business days of purchase, the number of
                    tokens purchased will be subject to average exchange rate 
                    on the day of receiving the amount on the bank account. 
                  </Typography>
                </React.Fragment>
              )}
              {currency === "DASH" && (
                <Typography align="right">
                  <small>
                    (1&nbsp;CRWDToken / {baserate_disp}&nbsp;ETH /{" "}
                    {dash_rate_disp}&nbsp;DASH -{" "}
                    <span style={{ whiteSpace: "nowrap" }}>
                      {rate_date_disp}
                    </span>
                    )
                  </small>
                </Typography>
              )}
            </Grid>
          </Grid>
        </TabContainer>
      </Paper>
    );
  }
}

export default withStyles(styles)(EnterMulticurrencyInvestmentValue);

// Closure
(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === "undefined" || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (
      value === null ||
      isNaN(value) ||
      !(typeof exp === "number" && exp % 1 === 0)
    ) {
      return NaN;
    }
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust("round", value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust("floor", value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust("ceil", value, exp);
    };
  }
})();
